import { httpClient } from '@shared/infrastructure/http/http-client.js';
import type { RealtimeTicket } from '../model.js';

interface TicketPayload {
  ticket: string;
  url: string;
  expires_at: string;
}

/**
 * Boundary with the live connection to Virtual Profiler.
 *
 * Like every other gateway of the module it goes through the back-office and never straight to
 * Virtual Profiler: the permission is checked there and the browser holds no service key. What
 * it gets back is a ticket the socket can present, plus the address to present it to.
 */
export const realtimeApi = {
  /**
   * Mints a ticket for one connection.
   *
   * Called again for every reconnection attempt, never cached: the ticket is single use and the
   * server has already consumed it by the time the socket is live.
   */
  ticket: async (): Promise<RealtimeTicket> => {
    const payload = await httpClient.get<TicketPayload>('/virtual-profiler/realtime/ticket');

    return {
      ticket: payload.ticket,
      url: payload.url,
      // Never null: a ticket that exists expires at some moment.
      expiresAt: new Date(payload.expires_at),
    };
  },
};
